import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";
import { formatString } from "../../../modules/common";

interface IProps {
  tooltipId?: string;
  children?: React.ReactNode;
  formatData?: any;
}

const ToolTipBox = ({ tooltipId, children, formatData }: IProps) => {
  const globalData = useGlobalData();

  const renderTooltip = (props: any) => {
    if (tooltipId && globalData.data?.Tooltip?.mapTooltip[tooltipId]) {
      let tooltipText = globalData.data?.Tooltip.mapTooltip[tooltipId];
      if (formatData) {
        tooltipText = formatString(tooltipText, formatData);
      }
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{tooltipText}</span>
        </Tooltip>
      );
    } else return <></>;
  };

  const getToolTipBox = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <>{children}</>
      </OverlayTrigger>
    );

    return htmlPart;
  };

  return <>{getToolTipBox()}</>;
};

export default ToolTipBox;
